<template>
  <b-form-group label="图片">
    <b-form-file
      browse-text="上传"
      ref="img-input"
      @input="uploadFile"
      placeholder="请选择图片"
      accept="image/*">
    </b-form-file>
  </b-form-group>
</template>

<script>
  export default {
    name: 'UploadImg',
    data() {
      return {
        postOss: this.getDomain() + 'article/uploadImg'
      }
    },
    methods: {
      uploadFile(file) {
        let articleForm = new FormData();
        articleForm.append('img', file, file.name);
        let config = {
          headers:{'Content-Type':'multipart/form-data'}
        };
        this.axios.post(this.postOss, articleForm, config).then(res => {
          if (res.data.status === 200) {
            this.$emit('getOssUrl', res.data.ossUrl)
          } else {
            this.$message.error('err:' + res.errorCode)
          }
        });
      }
    }
  }
</script>
